module.exports = {
	"title": "Physical changes",
	"standfirst": "52% think that people should change their appearance 👡 in order to fit in at work.",
	"viz1Title": "But why do we change our appearance at work?",
	"viz1": [
		{
			"fact": "Nature of the job",
			"percentage": "45"
		},
		{
			"fact": "Typical style doesn’t fit in with company style",
			"percentage": "14"
		},
		{
			"fact": "Typical style wouldn’t make a good impression",
			"percentage": "13"
		},
		{
			"fact": "Have been discriminated against",
			"percentage": "6"
		},
		{
			"fact": "Don’t want to draw attention to ethnicity",
			"percentage": "5"
		},
		{
			"fact": "Don’t want to draw attention to socio-economic background",
			"percentage": "4"
		}
	],
	"viz2Title": "If you’re LGBTQ+ you’re twice as likely to change your appearance at work because you’ve been discriminated against",
	"viz2": [
		{
			"fact": "of all",
			"percentage": "6",
			"color": "#82DEBC"
		},
		{
			"fact": "of LGBTQ+",
			"percentage": "12",
			"color": "#FECA98"
		}
	],
	"viz3Title": "Most people have no problem with tattoos ☠️🌹 at work, but many still worry 😰 about their body ink.",
	"viz3": [
		{
			"fact": "of respondents with tattoos are worried about people seeing them at work",
			"percentage": "42"
		},
		{
			"fact": "of respondents have no problem with tattoos at work",
			"percentage": "62"
		}
	],
	"viz4Title": "Why?",
	"viz4Subtitle": "When you have visible tattoos, respondents think…",
	"viz4": [
		{
			"fact": "It’s harder to get a job",
			"percentage": "60"
		},
		{
			"fact": "It's harder to be promoted",
			"percentage": "46"
		},
		{
			"fact": "Women are more likely to be discriminated against",
			"percentage": "48"
		},
		{
			"fact": "It's harder to be taken seriously at work",
			"percentage": "42"
		}
	],
	"viz5Title": "More women than men tend to think females are most likely to be discriminated against for tattoos",
	"viz5": [
		{
			"fact": "of women",
			"percentage": "58",
			"color": "#17ADA1",
			"factBelow": "true"
		},
		{
			"fact": "of men",
			"percentage": "39",
			"color": "#B3F36C"
		}
	],
	"viz6Title": "How about jewellery 💍?",
	"viz6Subtitle": "For some, it reveals a little too much. Including the fact you’re married.",
	"viz6Text1": "Out of 4,127 respondents...",
	"viz6Text2": "admitted to removing their wedding ring at work",
	"viz6Emoji": "💍",
	"viz6": [
		{
			"fact": "men",
			"number": "10"
		},
		{
			"fact": "women",
			"number": "13"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./copy/physical.txt
// module id = ix8B
// module chunks = 0